export default __webpack_public_path__ + "static/media/speaker.1e11f96b.png";